import { render, staticRenderFns } from "./FloatingChatroom.vue?vue&type=template&id=22b5c6f4&scoped=true&"
import script from "./FloatingChatroom.vue?vue&type=script&lang=js&"
export * from "./FloatingChatroom.vue?vue&type=script&lang=js&"
import style0 from "./FloatingChatroom.vue?vue&type=style&index=0&id=22b5c6f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b5c6f4",
  null
  
)

export default component.exports